import React from "react";
import { FaCheckCircle } from "react-icons/fa";

function ExploreDeFiPlatforms() {
  const tabs = [
    "DECENTRALIZED EXCHANGE",
    "LIQUIDITY PROTOCOL",
    "DERIVATIVES",
    "YIELD FARMING"
  ];

  return (
    <div className="about-area pt-5 pb-5 mt-4">
      <div className="container text-center">
        <div className="row">
          <div className="col-lg-8 offset-lg-2 mb-4">
            <h2 className="title fw-bold">
              Explore Our DeFi Development Services & Platforms We Offer
            </h2>
            <p className="mt-3" style={{ fontSize: "15px", color: "#555" }}>
              Unlock immensely flexible digital infrastructure architectures completely engineered scaling exact algorithmic
              market operations directly targeting superior asset decentralization frameworks seamlessly.
            </p>
          </div>
        </div>

        {/* Pseudo Tab Navigation */}
        <div className="d-flex justify-content-center flex-wrap mb-5 gap-3">
          {tabs.map((tab, i) => (
            <div
              key={i}
              className={`px-4 py-2 ${i === 0
                  ? "text-primary border-bottom border-primary border-2 fw-bold"
                  : "text-secondary"
                }`}
              style={{ cursor: "pointer", fontSize: "14px", letterSpacing: "1px" }}
            >
              <FaCheckCircle size={35} className="me-2" />
              {tab}
            </div>
          ))}
        </div>

        {/* Large Platform Image */}
        <div className="mt-4">
          <img
            src="/assets/img/illustration/4.png"
            alt="DeFi Platform Visualization"
            style={{
              maxWidth: "80%",
              borderRadius: "15px",
              boxShadow: "0 20px 50px rgba(0,0,0,0.15)"
            }}
          />
        </div>
      </div>
    </div>
  );
}

export default ExploreDeFiPlatforms;